export default __webpack_public_path__ + "static/cyber-security-de2fca421fd246c2b9be28cd47a99f23.png";